module.exports = __webpack_public_path__ + "img/touch-icon-iphone-retina.99399a71.png";